import { render } from "./admin_report.vue?vue&type=template&id=e772f2b8"
import script from "./admin_report.vue?vue&type=script&lang=js"
export * from "./admin_report.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__